import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useEditCar = (onSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (data: { number: string; name: string; id: string }) =>
      API.editCar(data.number, data.name, data.id),
    onSuccess: () => {
      onSuccess();
    },
    onError: (data) => {
      console.log(data);
    },
  });

  return {
    editCar: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
    errorEdit: mutation.error,
  };
};
